import { useTranslation } from "next-i18next";
import dayjs from "dayjs";

import Text from "ab-text";
import Link from "ab-link";

import "./ab-blog-small.scss";

const BlogSmall = ({ rtl, post, i18n }) => {
  const { t } = useTranslation("common", { i18n });

  return (
    <div className="ab-blog-small">
      <div className={rtl ? "rtl" : undefined}>
        <img src={post?.featuredImage?.node?.mediaItemUrl} alt={post.title} />
        <div>
          <Text element="span" className="title">
            {dayjs(post.date).format("DD/MM/YYYY")}
          </Text>
          <Text element="h3">{post.title}</Text>

          <Text>{post.contenidoFlexible?.modulos?.[0].excerpt}</Text>

          <Link
            prefetch={false}
            text={t("leer-mas")}
            href={`${t("/blog")}/${post.slug}`}
          ></Link>
        </div>
      </div>
    </div>
  );
};

export default BlogSmall;
